import {BarcodePicker, configure, ScanSettings} from "scandit-sdk";

export class Scanner {
    static async create(element, enabledSymbologies = ['code128']) {
        await configure(Scanner.key(), {
            engineLocation: 'https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build/',
        });

        return await BarcodePicker.create(
            element,
            {
                playSoundOnScan: false,
                vibrateOnScan: false,
                scanSettings: new ScanSettings({
                    enabledSymbologies,
                }),
            }
        );
    }

    /**
     * @private
     * @returns {string}
     */
    static key() {
        if (process.env.NODE_ENV !== 'development') {
            return "ATNA7YWBEa4GAlYNAyfnmqkDOXm7PI6NMhXCdVEaEz0FesdCVmz6FGFdklVWcjIFMzAwDFpD4sTMXy2pKGNLQxgU+79baRA25ET5VuN8sZCSdYIpIC/9aR9Qsqm7aRnQgEMQNoREhInZDhogxSWVA05VO9E0Mwk83rIOD81XLXsKmvvtV77PFC6WyMayiGD2FcCuThv30qeDfrWQuOJJLEpftonFLmpcs0ypml2+I2dfSIoM3NT+3m2TpRN/HtNdVuBZB+fyYeP1teuI3f8pP7HQF/4mGvSc/GGM2Rnh7eLW+QflAYKplIUqynEVxgecD6atECggtSc9GlxK9yqPUA1/auoq1VVPyXrX0dk/BpDrfb65hLbJhh4sDZjoqnr9XrKtQNXFImzH8xxPNUvSPpBeJA5f+ZT9lWR9bEYa/2WB7aDr5UkPn4cegSXd+FSMsBHEUOtzWtiw+uyxotZS7Y92qB7j/nPkpGdDm9EVvdRWvPba/5781hiizuC/v90JLrrCy8KPgmbT+V66v72ChVg0pJhMlOrPFDRes3KvTKTys71Q26dBje/tryXoiPXGlhDDr3yOziqZzhb1Ux8KPXtfJ9iWvD/0gMXbG1AFEqtQMWGslXfv1y5pAUPna0acLJNeLXu2UpkH3hy1CXHGkmv0nwGaPV2hTj0Hn7SZboBT7Zpnvr18+SpERkuRk07spofz3UMLAvz5UxsvQgePxOS4rCZvAM1OPrnU8kz7Tb5c3KaAlAZ1GDr+r0AaJVssOp0DMum9qhPcMegbrU+X/Lte3EZPP66Bf+wj576nrgssJIy6WKMa84PWwx634PiU";
        }

        return "AdeA+B3rPrIdBX2sLCg4cmAvgC3VFtB3Bjj2gaU4x7LCOsDrHkdCv2ZrFWsvWzYjtG4WVRZCdnLHYJdlpWO9hGEwm6nVLf4u2V7EUV5tFfO2f7WxMX/IJfREDqKsSCYQq0o6hXkb2UdTLyP5uxOogG1E3TvU3hVArlpKnLZoey67ppHXxkRzWnF7DzMyMRYSUX4Qbov55jUewg7P88Ka/xlSAEB8X7YdqXTbPRGY5GXCzRB8r9hs7s0HQ5zTgxhXCV6cW73sXCIl3HlOKh/MFbXGQbwbURT48hlA991abXOLTSd0j4u3YN1bjzmuudGETSoIDOtkKEA6YNJdU28dS2Bbu6WAy/FOxrNt2yvAsbMj70u6UNb8AdpYqMqogqcgcZNDJHy1ZWMwXRD0uJ+vJfQjAel6FVhbdUhIpJjivnT0cPmB27Ylrpm5/Wfd3H2Z1l2OKLO1AwcsxfabxDek5Rq7/jEvRVpq4QacFq4FYvXHifxPogCSbnLOfKKgbaocPl9b28MlTMqRdcU23K5OZt7wyALIswjE6v0SOgU1kYPiCO09moPCWkVqrnR2ZvCtwFEbOFViNfETr0gVvHTq0j2/vufsVqFgOY1KawLD7PSaslCvDOsnqXpnGGB1aULFWpdgTcKL8aCKvI6gOlYYMw73ytovbl1a/fHFZKY/I8Pv8BCusV+njwm+1LpTfLD6a7RpV+VmJOnGOxWyeXgkRqqvw1YO8E09ntwnCjcrntE+wTrpLEbQe2qdRJd5YA133SYMXTh73TAhDSo/4YxTEOywt/CVTYqWd2DgP1rtcAJpzrMXeMFdNsosI6+2T6jsHnpPbQ==";
    }
}
